<div class="page-layout">
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Brain"
      pageSubtitle="Watch connected sources flow into the knowledge core">
    </app-navbar>

    <div class="content">

      <!-- LEFT: Document Sources -->
      <div class="sources-panel">
        <div class="panel-header">
          <h3 class="panel-title">Document Sources</h3>
          <p class="panel-subtitle">{{ connectedSourceCount() }} connected</p>
        </div>

        <div class="sources-list">
        <!-- GitHub -->
        <div class="source-card" [class.live]="ghLive()" [class.live-gh]="ghLive()">
          <button type="button" class="source-header" (click)="toggleGH()">
            <span class="src-icon gh">
              <app-brand-icon name="github" [size]="18"></app-brand-icon>
            </span>
            <span class="src-name">GitHub</span>
            <span class="status-dot" [class.dot-on]="isGitHubConnected()" [class.dot-off]="!isGitHubConnected()"></span>
            <svg class="chevron" [class.open]="ghExpanded()" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A0A8BF" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="source-items" *ngIf="ghExpanded()">
            <div class="empty-row" *ngIf="repos().length === 0">No repositories selected.</div>
            <div class="source-item-wrap" *ngFor="let r of repos(); trackBy: trackByRepoName">
              <div class="source-item">
                <div class="item-left">
                  <span class="item-dot"
                    [class.item-dot-active]="r.status === 'ingesting'"
                    [class.item-dot-done]="r.status === 'completed'"
                    [class.item-dot-fail]="r.status === 'failed'">
                  </span>
                  <div class="item-info">
                    <span class="item-name">{{ r.name }}</span>
                    <span class="item-sub" *ngIf="r.status === 'completed'">Completed</span>
                    <span class="item-sub active-sub" *ngIf="r.status === 'ingesting'">Ingesting…</span>
                  </div>
                </div>
                <span class="item-badge"
                  [class.badge-processing]="r.status === 'ingesting'"
                  [class.badge-done]="r.status === 'completed'"
                  [class.badge-fail]="r.status === 'failed'"
                  [class.badge-idle]="r.status === 'idle'">
                  {{ r.status === 'idle' ? 'Idle' : r.status === 'ingesting' ? 'Ingesting' : r.status === 'completed' ? 'Done' : 'Failed' }}
                </span>
              </div>
              <div class="progress-bar gh-bar indeterminate" *ngIf="r.status === 'ingesting'">
                <div class="progress-fill"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Document sources -->
        <div class="source-card"
          *ngFor="let g of docGroups(); trackBy: trackByGroup"
          [class.live]="g.live"
          [class.live-sp]="g.live"
          [style.--doc-border]="g.theme.cardBorder"
          [style.--doc-shadow]="g.theme.cardShadow"
          [style.--doc-bar]="g.theme.bar">
          <button type="button" class="source-header" (click)="toggleDoc(g.key)">
            <span class="src-icon" [style.background]="g.theme.iconBg">
              <app-brand-icon [name]="g.theme.icon" [size]="18"></app-brand-icon>
            </span>
            <span class="src-name">{{ g.theme.label }}</span>
            <span class="status-dot" [class.dot-on]="g.online" [class.dot-off]="!g.online"></span>
            <svg class="chevron" [class.open]="isDocExpanded(g.key)" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A0A8BF" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="source-items" *ngIf="isDocExpanded(g.key)">
            <div class="empty-row" *ngIf="g.batches.length === 0">No batches yet.</div>
            <div class="source-item-wrap" *ngFor="let b of g.batches; trackBy: trackByBatchId">
              <div class="source-item">
                <div class="item-left">
                  <span class="item-dot"
                    [class.item-dot-active]="isBatchActive(b)"
                    [class.item-dot-done]="b.status === 'Completed'"
                    [class.item-dot-fail]="b.status === 'Failed'">
                  </span>
                  <div class="item-info">
                    <span class="item-name">{{ b.name }}</span>
                    <span class="item-sub" *ngIf="b.status === 'Completed'">Completed · {{ timeAgo(b.completedAt) }}</span>
                    <span class="item-sub active-sub" *ngIf="isBatchActive(b)">{{ b.processedDocuments + b.failedDocuments }}/{{ b.totalDocuments }} docs</span>
                  </div>
                </div>
                <span class="item-badge"
                  [class.badge-processing]="isBatchActive(b)"
                  [class.badge-done]="b.status === 'Completed'"
                  [class.badge-fail]="b.status === 'Failed'"
                  [class.badge-idle]="b.status === 'Draft'">
                  {{ batchLabel(b) }}
                </span>
              </div>
              <div class="progress-bar doc-bar" *ngIf="isBatchActive(b)">
                <div class="progress-fill" [style.width.%]="b.percentComplete"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Outlook -->
        <div class="source-card" [class.live]="emailLive()" [class.live-email]="emailLive()">
          <button type="button" class="source-header" (click)="toggleOutlook()">
            <span class="src-icon outlook">
              <app-brand-icon name="outlook" [size]="18"></app-brand-icon>
            </span>
            <span class="src-name">Outlook</span>
            <span class="status-dot" [class.dot-on]="!!outlookConnection()" [class.dot-off]="!outlookConnection()"></span>
            <svg class="chevron" [class.open]="outlookExpanded()" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A0A8BF" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="source-items" *ngIf="outlookExpanded()">
            <div class="empty-row" *ngIf="!outlookConnection()">No mailbox connected.</div>
            <ng-container *ngIf="outlookConnection()">
              <div class="empty-row" *ngIf="emailBatches().length === 0">No email batches yet.</div>
              <div class="source-item-wrap" *ngFor="let b of emailBatches(); trackBy: trackByBatchId">
                <div class="source-item">
                  <div class="item-left">
                    <span class="item-dot"
                      [class.item-dot-active]="isBatchActive(b)"
                      [class.item-dot-done]="b.status === 'Completed'"
                      [class.item-dot-fail]="b.status === 'Failed'">
                    </span>
                    <div class="item-info">
                      <span class="item-name">{{ b.name }}</span>
                      <span class="item-sub" *ngIf="b.status === 'Completed'">Completed · {{ timeAgo(b.completedAt) }}</span>
                      <span class="item-sub active-sub" *ngIf="isBatchActive(b)">{{ b.processedDocuments + b.failedDocuments }}/{{ b.totalDocuments }} emails</span>
                    </div>
                  </div>
                  <span class="item-badge"
                    [class.badge-processing]="isBatchActive(b)"
                    [class.badge-done]="b.status === 'Completed'"
                    [class.badge-fail]="b.status === 'Failed'"
                    [class.badge-idle]="b.status === 'Draft'">
                    {{ batchLabel(b) }}
                  </span>
                </div>
                <div class="progress-bar email-bar" *ngIf="isBatchActive(b)">
                  <div class="progress-fill" [style.width.%]="b.percentComplete"></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        </div>
      </div>

      <!-- CENTER: Brain visualization -->
      <div class="brain-panel" [class.is-live]="isFlowing()">
        <div class="viz-status">
          <span class="status-chip" [class.live]="isFlowing()">
            <span class="status-led"></span>
            {{ isFlowing() ? 'Live ingestion' : 'Core ready' }}
          </span>
        </div>

        <div class="viz-sizer">
        <div #vizWrap class="viz-wrap"
          [style.--doc-disc]="activeDocTheme().disc"
          [style.--doc-disc-stroke]="activeDocTheme().discStroke"
          [style.--doc-halo]="activeDocTheme().halo"
          [style.--doc-label]="activeDocTheme().labelColor">

        <div class="brain-core"
          [class.active]="isFlowing()"
          [class.resting]="!isFlowing()"
          [style.--brain-dot]="brainPalette().fill"
          [style.--brain-line]="brainPalette().stroke"
          [style.--brain-glow]="brainPalette().glow">
          <div class="core-bloom"></div>
          <div class="core-orbit orbit-a"></div>
          <div class="core-orbit orbit-b"></div>
          <div class="core-orbit orbit-c"></div>
          <div #brainLottie class="brain-lottie" role="img" aria-label="Voyager knowledge core"></div>
        </div>

        <svg class="flow-svg" viewBox="0 0 540 480" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
          <defs>
            <linearGradient id="ghGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stop-color="#24292F"/>
              <stop offset="100%" stop-color="#C9D1D9"/>
            </linearGradient>
            <linearGradient id="spGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" [attr.stop-color]="flowDocPalette().stroke"/>
              <stop offset="100%" [attr.stop-color]="flowDocPalette().fill"/>
            </linearGradient>
            <linearGradient id="emailGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stop-color="#0078D4"/>
              <stop offset="100%" stop-color="#93C5FD"/>
            </linearGradient>
            <filter id="pathGlow" filterUnits="userSpaceOnUse" x="0" y="0" width="540" height="480">
              <feGaussianBlur stdDeviation="2.2" result="blur"/>
              <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
            </filter>
          </defs>

          <path id="ghPath"
            class="synapse"
            [class.idle]="!ghLive()"
            [class.live]="ghLive()"
            [class.live-gh]="ghLive()"
            [attr.stroke]="ghLive() ? 'url(#ghGrad)' : null"
            d="M78,96 C180,96 200,190 210,208"/>

          <path id="spPath"
            class="synapse"
            [class.idle]="!spLive()"
            [class.live]="spLive()"
            [class.live-sp]="spLive()"
            [attr.stroke]="spLive() ? 'url(#spGrad)' : null"
            d="M78,240 C175,238 195,242 208,240"/>

          <path id="emailPath"
            class="synapse"
            [class.idle]="!emailLive()"
            [class.live]="emailLive()"
            [class.live-email]="emailLive()"
            [attr.stroke]="emailLive() ? 'url(#emailGrad)' : null"
            d="M78,384 C180,384 200,290 210,272"/>

          <!-- Source nodes -->
          <g class="src-node-g" [class.live]="ghLive()">
            <circle class="src-halo gh" cx="40" cy="96" r="34"/>
            <circle class="src-disc gh" cx="40" cy="96" r="26"/>
            <text x="40" y="54" text-anchor="middle" class="src-label gh-label">GitHub</text>
          </g>

          <g class="src-node-g" [class.live]="spLive()">
            <circle class="src-halo sp" cx="40" cy="240" r="34"/>
            <circle class="src-disc sp" cx="40" cy="240" r="26"/>
            <text x="40" y="198" text-anchor="middle" class="src-label sp-label">{{ activeDocTheme().shortLabel }}</text>
          </g>

          <g class="src-node-g" [class.live]="emailLive()">
            <circle class="src-halo outlook" cx="40" cy="384" r="34"/>
            <circle class="src-disc outlook" cx="40" cy="384" r="26"/>
            <text x="40" y="342" text-anchor="middle" class="src-label email-label">Outlook</text>
          </g>
        </svg>

        <canvas #flowCanvas class="flow-canvas" aria-hidden="true"></canvas>

        <div class="viz-logo gh" aria-hidden="true">
          <app-brand-icon name="github" [fluid]="true"></app-brand-icon>
        </div>
        <div class="viz-logo sp" aria-hidden="true">
          <app-brand-icon [name]="activeDocTheme().icon" [fluid]="true"></app-brand-icon>
        </div>
        <div class="viz-logo outlook" aria-hidden="true">
          <app-brand-icon name="outlook" [fluid]="true"></app-brand-icon>
        </div>
        </div>
        </div>

        <div class="viz-footer">
          <div class="flow-pills" *ngIf="isFlowing()">
            <span class="pill"
              *ngFor="let g of liveDocGroups(); trackBy: trackByGroup"
              [style.background]="g.theme.pillBg"
              [style.color]="g.theme.pillFg">{{ g.theme.shortLabel }} · {{ groupProgress(g) }}</span>
            <span class="pill gh-pill"    *ngIf="ghLive()">{{ ghProgressLabel() }}</span>
            <span class="pill email-pill" *ngIf="emailLive()">{{ emailProgressLabel() }}</span>
          </div>
          <p class="idle-hint" *ngIf="!isFlowing()">
            Start a batch or trigger repo ingestion to see data flow in real time.
          </p>
        </div>
      </div>

      <!-- RIGHT: Insights -->
      <div class="insights-panel">
        <div class="panel-header">
          <h3 class="panel-title">Insights</h3>
          <p class="panel-subtitle">Extracted intelligence</p>
        </div>

        <div class="insights-list">
        <div class="insight-tile">
          <div class="insight-icon-wrap classify-color">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.59a2 2 0 0 0 2.83 0l4.59-4.59a2 2 0 0 0 0-2.83z"/>
              <line x1="7" y1="7" x2="7.01" y2="7"/>
            </svg>
          </div>
          <div class="insight-body">
            <span class="insight-label">Document Classification</span>
            <span class="insight-value" *ngIf="insights() as ins">
              {{ ins.classifiedDocumentCount > 0 ? (ins.classifiedDocumentCount + ' Categories Identified') : 'No documents classified yet' }}
            </span>
            <span class="insight-value" *ngIf="!insights()">Building…</span>
          </div>
        </div>

        <div class="insight-tile">
          <div class="insight-icon-wrap topics-color">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/>
              <line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/>
            </svg>
          </div>
          <div class="insight-body">
            <span class="insight-label">Key Topics &amp; Themes</span>
            <span class="insight-value" *ngIf="insights() as ins">
              {{ ins.distinctRoleCount > 0 ? (ins.distinctRoleCount + ' Topics Extracted') : 'No themes identified yet' }}
            </span>
            <span class="insight-value" *ngIf="!insights()">Building…</span>
          </div>
        </div>

        <div class="insight-tile">
          <div class="insight-icon-wrap entities-color">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
            </svg>
          </div>
          <div class="insight-body">
            <span class="insight-label">Entities &amp; Relationships</span>
            <span class="insight-value" *ngIf="insights() as ins">
              {{ ins.entityCount > 0 ? (ins.entityCount + ' Entities Mapped') : 'No entities extracted yet' }}
            </span>
            <span class="insight-value" *ngIf="!insights()">Building…</span>
          </div>
        </div>

        <div class="insight-tile">
          <div class="insight-icon-wrap sentiment-color">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
            </svg>
          </div>
          <div class="insight-body">
            <span class="insight-label">Sentiment &amp; Trends</span>
            <span class="insight-value" *ngIf="insights() as ins">
              {{ ins.relationshipCount > 0 ? (ins.relationshipCount + ' Trends Identified') : 'No trends yet' }}
            </span>
            <span class="insight-value" *ngIf="!insights()">Building…</span>
          </div>
        </div>

        <div class="insight-tile">
          <div class="insight-icon-wrap graph-color">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="2" width="8" height="8" rx="1"/><rect x="14" y="2" width="8" height="8" rx="1"/>
              <rect x="2" y="14" width="8" height="8" rx="1"/><rect x="14" y="14" width="8" height="8" rx="1"/>
            </svg>
          </div>
          <div class="insight-body">
            <span class="insight-label">Knowledge Graph</span>
            <span class="insight-value" *ngIf="insights() as ins">
              {{ ins.graphDocumentCount > 0 ? (ins.graphDocumentCount + ' Documents in Graph') : 'Building Connections' }}
            </span>
            <span class="insight-value" *ngIf="!insights()">Building Connections</span>
          </div>
        </div>
        </div>
      </div>

    </div>
  </div>
</div>
